/* eslint-disable react-hooks/exhaustive-deps */
import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import 'swiper/css'

function AltriEventiRegione({ regione, flag, flag2, onChiudi, dettagliIsOpen }) {
    const navigate = useNavigate()
    const oggi = new Date().toLocaleDateString('sv-SE').replace(/-/g, '/')

    const [eventi, setEventi] = useState([])
    const [evento, setEvento] = useState(null)
    const [msg, setMsg] = useState({ evtInCorso: null })

    async function getEvent(a) {
        const res = await axios.get(`/getEventByRegion/${a}`)
        const oggi = new Date().toLocaleDateString('sv-SE').replace(/-/g, '/')
        if (res.data !== "non ci sono altri eventi")
            setEventi(res.data.filter(x => x.dataFine.replace(/-/g, "/") >= oggi))
    }
    function dettagliEvt(id) {
        setEvento(eventi.filter(item => item.id === id))
        dettagliIsOpen('secondoRegioni')
    }
    useEffect(() => {
        if (evento) {
            if (oggi >= evento[0].dataInizio.replace(/-/g, "/") && oggi <= evento[0].dataFine.replace(/-/g, "/")) {
                setMsg({ ...msg, evtInCorso: "Evento in corso" })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [evento])

    useEffect(() => { if (flag === 'primoRegioni') { getEvent(regione) } }, [flag])

    // useEffect(() => { console.log('eventi:', eventi) }, [eventi])
    return (<>
        <div className={`divNotifiche${flag === 'primoRegioni' || flag2 === 'secondoRegioni' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={() => { window.history.back() }}>◀
            </button><hr />
            <p className='mt-3 p-1 text-center'><b>Eventi in {regione}</b></p>
            <div style={{ overflowY: 'auto', height: '80%' }}>
                {eventi.length !== 0 &&
                    eventi.map(x => {
                        let vg = ''
                        if (oggi >= x.dataInizio.replace(/-/g, "/") && oggi <= x.dataFine.replace(/-/g, "/")) {
                            // eslint-disable-next-line no-unused-vars
                            vg = "in corso"
                        }
                        return (
                            <p style={{ cursor: 'pointer', backgroundColor: 'lightgrey', padding: '5px' }} key={x.id}
                                onClick={() => { dettagliEvt(x.id) }}>
                                {x.titolo} - {x.provincia} <i className='text-success'>{vg}</i>
                            </p>
                        )
                    })
                }
                {eventi.length === 0 && <p className='text-center'>Nessun Evento in programma o Eventi già avvenuti</p>}
            </div>
        </div>

        {/* --------------------- BANNER DETTAGLI EVENTO ------------------ */}
        <div className={`divNotifiche${flag2 === 'secondoRegioni' ? 'Aperto' : ''}`} style={{ marginTop: '-4em', height: '100%', padding: '3px' }}>
            <button style={{ fontSize: 'xx-large', border: 'none' }}
                onClick={() => {
                    setMsg({ evtInCorso: null })
                    window.history.back()
                }}>◀
            </button><hr />
            {evento &&
                <div className='p-1'>
                    <p className='fs-4'><b>{evento[0].titolo}</b></p>
                    {evento[0].img &&
                        <img src={`https://leuro-bucket.s3.amazonaws.com/${evento[0].img.split(',')[0]}`} width={282} height={230} className='rounded'
                            style={{ objectFit: 'cover' }} alt='' />
                    }
                    {evento[0].sottotitolo &&
                        <p className='mt-3'>{evento[0].sottotitolo}</p>
                    }
                    <b>{evento[0].dataInizio.split("-").reverse().join("-")}</b>
                    {evento[0].dataFine &&
                        <span> ⇉ <b>{evento[0].dataFine.split("-").reverse().join("-")}</b></span>
                    }
                    <p className='mt-3'>
                        <img src={require('../image/icons8-visita-24.png')} alt='' /> {evento[0].comune}, <i>{evento[0].città}</i> ({evento[0].provincia})
                    </p>
                    {msg.evtInCorso && <p className='text-success'><b>{msg.evtInCorso}</b></p>}

                    <button className='btn btn-primary' onClick={() => {
                        document.body.style.overflow = "scroll"
                        onChiudi(evento[0].id)
                    }}>VAI ALL'EVENTO
                    </button>
                </div>
            }
        </div>
    </>)
}
export default AltriEventiRegione